import { Flex, Text, VStack } from '@chakra-ui/react';
import { LeagueListRow } from '@/views/RulesPage/LeagueListRow';
import { LeaderboardRow } from '@/views/LeaguePage/LeaderboardRow';
import { pageSectionTitleProps } from '@/theme/sitePageTypography';
import { HOME_GLOBAL_LEADERBOARD_ROWS, HOME_LEAGUES_LIST_DEMO } from './homeJoinLeagueDemo';

export function HomeJoinLeaguePreview() {
  return (
    <Flex
      flexDir={{ base: 'column', lg: 'row' }}
      maxW='full'
      w='full'
      gap={{ base: 6, md: 8 }}
      align='flex-start'
    >
      <VStack align='stretch' spacing={2} flex={1} minW={0} w='full'>
        <Text {...pageSectionTitleProps}>Global League</Text>
        <VStack align='stretch' spacing={1} w='full'>
          {HOME_GLOBAL_LEADERBOARD_ROWS.map((row) => (
            <LeaderboardRow key={row.memberUid} {...row} readOnly />
          ))}
        </VStack>
      </VStack>

      <VStack align='stretch' spacing={2} flex={1} minW={0} w='full'>
        <Text {...pageSectionTitleProps}>Leagues</Text>
        <Flex direction='column' width='full' gap={2}>
          {HOME_LEAGUES_LIST_DEMO.map(({ league: leagueData, memberData, isAdmin }) => (
            <LeagueListRow
              key={leagueData.name}
              league={leagueData}
              memberData={memberData}
              isAdmin={isAdmin ?? false}
              tournamentStarted
            />
          ))}
        </Flex>
      </VStack>
    </Flex>
  );
}
